import { render, staticRenderFns } from "./invoice-payment-card-v2.vue?vue&type=template&id=2a40fe92&scoped=true&"
import script from "./invoice-payment-card-v2.vue?vue&type=script&lang=js&"
export * from "./invoice-payment-card-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a40fe92",
  null
  
)

export default component.exports